// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2e0sP","buttons":"PendingPaymentAlert_buttons__21R_3"};